import { SimpleGrid, Box, Image, Text, Link, Container } from "@chakra-ui/react";
import { useEffect, useState } from 'react'

export default function ShopOurCategories() {
    const [categories, setShopOurCategories] = useState<any>([]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/home-shop-our-categories`)
            .then((response) => response.json())
            .then((data) => setShopOurCategories(data));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container maxW="1200px" py={10}>
            <Box py={10} textAlign="center">
                <Text fontSize="2xl" mb={6} fontWeight="bold">
                    SHOP OUR CATEGORIES
                </Text>

                <SimpleGrid 
                    columns={{ base: 2, md: 3 }} 
                    spacing={{ base: 4, md: 8 }} 
                    p={{ base: 4, md: 10 }}
                >
                    {categories.map((cat: { id: number; name: string; link: string; image: string }) => (
                        <Link 
                        key={cat.id} 
                        href={'/products/' + cat.name} 
                        _hover={{ textDecoration: "none" }}
                        >
                        <Box 
                            _hover={{ transform: "scale(1.03)" }} 
                            transition="0.3s"
                        >
                            <Image
                            src={process.env.REACT_APP_API_URL+'/optimized-image'+cat.image}
                            alt={cat.name}
                            borderRadius="md"
                            w="100%"
                            h={{ base: "150px", sm: "200px", md: "250px" }}
                            objectFit="cover"
                            mb={3}
                            />
                            <Text 
                            fontSize={{ base: "sm", sm: "md", md: "lg" }} 
                            fontWeight="semibold"
                            textAlign="center"
                            >
                            {cat.name.toUpperCase()}
                            </Text>
                        </Box>
                        </Link>
                    ))}
                </SimpleGrid>

            </Box>
        </Container>
    );
}
